import { CircularProgress } from '@mui/material';
import React from 'react';

export default function CommonButton(props) {
  const {
    onClick,
    active = true,
    text,
    margin,
    loading = false,
    minWidth, maxWidth,
    minHeight, maxHeight,
    fontSize,
    padding
  } = props;

  const extraStyle = () => {
    const style = {};
    if (padding) style.padding = padding;
    if (minWidth) style.minWidth = minWidth;
    if (maxWidth) style.maxWidth = maxWidth;
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    if (fontSize) style.fontSize = fontSize;
    if (margin) style.margin = margin;
    return style;
  };

  return (
    <button
      className={`common-button ${active && !loading ? 'active' : 'disable'}`}
      style={extraStyle()}
      variant="contained"
      onClick={() => {
        if (active && !loading) {
          onClick();
        }
      }}
    >
      {!loading && (<span>{text}</span>)}
      {loading && <CircularProgress size={24} />}
    </button>
  );
}